import { render, staticRenderFns } from "./NotesPortlet.vue?vue&type=template&id=eb7c67d4&"
import script from "./NotesPortlet.vue?vue&type=script&lang=js&"
export * from "./NotesPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports